<template>
  <footer class="jcy-footer-wrapper">
    <div class="jcy-footer">
        <router-link :to="tab.url"
        class="jcy-footer-item"
        :class="{active: active === tab.name}"
        v-for="tab in tabs"
        :key="tab.name">
            <img :src="active === tab.name ? tab.activeImg : tab.img"/>
            <p>{{tab.name}}</p>
        </router-link>
    </div>
  </footer>
</template>

<script>
const COMPONENT_NAME = 'jcy-footer'
export default {
  name: COMPONENT_NAME,
  data () {
    return {
      active: '',
      tabs: [
        {
          name: '首页',
          url: '/',
          img: require('@/assets/images/footer/home.svg'),
          activeImg: require('@/assets/images/footer/home_active.svg')
        },
        {
          name: '商城',
          url: '/mall',
          img: require('@/assets/images/footer/mall.svg'),
          activeImg: require('@/assets/images/footer/mall_active.svg')
        },
        {
          name: '购物车',
          url: '/cart',
          img: require('@/assets/images/footer/cart.svg'),
          activeImg: require('@/assets/images/footer/cart_active.svg')
        },
        {
          name: '我的',
          url: '/my',
          img: require('@/assets/images/footer/my.svg'),
          activeImg: require('@/assets/images/footer/my_active.svg')
        }
      ]
    }
  },
  watch: {
    '$route' () {
      this.init()
    }
  },
  methods: {
    init () {
      this.tabs.forEach(tab => {
        let path = this.$route.path
        if (tab.url === path) {
          this.active = tab.name
        } else if (path !== '/' && this.$route.path.startsWith(tab.url)) {
          this.active = tab.name
        }
      })
    }
  },
  mounted () {
    this.init()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/footer/footer.vue